import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class IndicadorVendaOficinaService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/indicador_venda_oficina`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    partNumber?: any,
    numeroOs?: any,
    numeroChassi?: any,
    tipo?: any,
    original?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/indicador_venda_oficina/'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('partNumber', partNumber.toString())
        .set('numeroOs', numeroOs.toString())
        .set('numeroChassi', numeroChassi.toString())
        .set('tipo', tipo.toString())
        .set('original', original ? original.toString() : '')
    });
  }
}
